import React, { FC, ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Text } from '../../../redesign/text/textStyles'

const Container = styled.div`
    display: flex;
    padding: 4px;
    column-gap: 4px;
    background-color: #f2f2f2;
    width: fit-content;
    border-radius: 34px;
    box-sizing: border-box;
    position: relative;
`

const Slider = styled.span<{ $width: string; $height: string; $left: string }>`
    display: block;
    position: absolute;
    background-color: white;
    border-radius: 32px;
    height: ${(p) => p.$height};
    width: ${(p) => p.$width};
    left: ${(p) => p.$left};
    transition:
        left 0.3s ease-in-out,
        width 0.1s ease-in-out;

    box-shadow:
        0px 1px 1px 0px rgba(0, 0, 0, 0.03),
        0px 0px 2px 0px rgba(0, 0, 0, 0.1),
        0px 5px 5px 0px rgba(0, 0, 0, 0.03);
    backdrop-filter: blur(10px);
`

const Button = styled.button`
    cursor: pointer;
    padding: 8px 24px;
    border-radius: 32px;
    border-width: 0px;
    background: transparent;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
`

interface SlidingTabItem {
    id: string
    name: string
    children?: ReactNode
}

interface Props {
    items: SlidingTabItem[]
    onTabChange: React.Dispatch<React.SetStateAction<number>>
}

export const SlidingTabBar: FC<Props> = ({ items, onTabChange }) => {
    const tabsRef = useRef<(HTMLElement | null)[]>([])
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const [sliderLeft, setSliderLeft] = useState(0)
    const [sliderWidth, setSliderWidth] = useState(0)
    const [sliderHeight, setSliderHeight] = useState(0)

    useEffect(() => {
        if (!tabsRef) return
        const currentTab = tabsRef.current[activeTabIndex] as HTMLElement
        setSliderLeft(currentTab?.offsetLeft ?? 0)
        setSliderWidth(currentTab?.clientWidth ?? 0)
        setSliderHeight(currentTab?.clientHeight ?? 0)
    }, [tabsRef, activeTabIndex])

    return (
        <Container>
            <Slider
                $width={`${sliderWidth}px`}
                $height={`${sliderHeight}px`}
                $left={`${sliderLeft}px`}
            />

            {items.map((item, index) => {
                return (
                    <Button
                        ref={(element) => (tabsRef.current[index] = element)}
                        key={index}
                        onClick={() => {
                            setActiveTabIndex(index)
                            onTabChange(index)
                        }}
                    >
                        <Text
                            size="medium"
                            $weight="medium"
                            color={
                                activeTabIndex == index
                                    ? 'primary'
                                    : 'secondary'
                            }
                        >
                            {item.name}
                        </Text>

                        {item.children}
                    </Button>
                )
            })}
        </Container>
    )
}
